export default "__VITE_ASSET__B6286I$a__"